import { css } from '@microsoft/fast-element';

export const genericFormStyling = css`
  zero-text-field,
  zero-number-field {
    padding-bottom: 8px;
  }

  zero-text-field.required,
  zero-number-field.required,
  zero-text-area.required,
  zero-select.required,
  zero-multiselect.required,
  zero-text-field.with-error,
  zero-number-field.with-error,
  zero-text-field.with-standing-message,
  zero-number-field.with-standing-message,
  .form-control.with-error {
    position: relative;
  }

  zero-text-field::part(label),
  zero-number-field::part(label),
  zero-text-area::part(label) {
    padding-left: 10px;
    margin: 8px 0;
  }

  zero-text-field.required::before,
  zero-number-field.required::before,
  zero-text-area.required::before {
    content: '*';
    position: absolute;
    left: 0;
    top: 8px;
    color: var(--error);
  }

  zero-text-field .error-message,
  zero-number-field .error-message,
  zero-text-area .error-message,
  .form-control .error-message {
    position: absolute;
    left: 0;
    bottom: -2px;
    padding-left: 10px;
    font-size: 12px;
    color: var(--error);
    font-family: Roboto-Regular, Roboto, sans-serif;
  }

  zero-text-field .standing-message,
  zero-number-field .standing-message,
  zero-text-area .standing-message,
  .form-control .standing-message {
    position: absolute;
    left: 0;
    bottom: -2px;
    padding-left: 10px;
    font-size: 12px;
    color: var(--cascade-light-gray);
    font-family: Roboto-Regular, Roboto, sans-serif;
  }

  zero-text-field.with-error,
  zero-number-field.with-error,
  zero-text-field.with-standing-message,
  zero-number-field.with-standing-message {
    padding-bottom: 20px;
  }

  zero-text-area.with-error,
  zero-text-area.with-standing-message {
    padding-bottom: 15px;
  }

  zero-text-field.with-error::part(root),
  zero-number-field.with-error::part(root),
  zero-text-area.with-error::part(control) {
    border-color: var(--error);
  }

  zero-text-field:focus-within:not([disabled])::part(root),
  zero-number-field:focus-within:not([disabled])::part(root),
  zero-text-area:focus-within:not([disabled])::part(control),
  zero-select:focus-within:not([disabled]) {
    border-color: var(--primary-color);
  }

  zero-option.selected {
    color: var(--primary);
  }

  zero-option:not([disabled])[aria-selected='true']:hover {
    background-color: var(--primary-color);
  }

  .form-control {
    font-size: var(--base-font-size);
    padding-bottom: 10px;
  }

  .form-control.with-error,
  .form-control.with-standing-message {
    padding-bottom: 20px;
  }

  .form-control.with-error:has(.range-value),
  .form-control.with-standing-message:has(.range-value) {
    padding-bottom: 7px !important;
  }

  .form-control label {
    color: var(--font-color-1);
    margin: 8px 0;
    height: 20px;
    display: flex;
    align-items: center;
  }

  .form-control zero-segmented-control {
    margin: 0;
  }

  .form-control.required {
    position: relative;
  }

  .form-control.required label {
    padding-left: 10px;
  }

  .form-control.required label::before {
    content: '*';
    position: absolute;
    left: 0;
    color: var(--error);
  }

  .form-control.required:not(:has(label))::before {
    content: '*';
    position: absolute;
    left: 0;
    top: 6px;
    color: var(--error);
  }

  .form-control zero-text-field[type='date'],
  .form-control zero-number-field {
    padding: 0;
  }

  .form-control:has(zero-text-field[type='date']) label {
    margin-bottom: 0;
  }

  zero-segmented-control::part(positioning-region) {
    width: 100%;
  }

  .light-gray-title {
    font-size: 12px;
    color: var(--cascade-light-gray);
  }

  zero-text-field[type='date']::part(control::placeholder),
  zero-text-field[type='date']::part(control)::placeholder {
    color: grey;
  }

  .form-control.long-error .error-message,
  .form-control.long-error .standing-message {
    position: relative;
    display: inline-block;
  }
`;
